(function () {
  if (window.HdPromo) { window.HdPromo.initAll(); return; }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  // "2026-11-27 20:00" + tz "-05:00" → timestamp. Chấp nhận cả ISO đầy đủ có Z/offset.
  function parseDate(s, tz) {
    if (!s) return NaN;
    s = String(s).trim().replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += 'T00:00';
    if (/T\d{1,2}:\d{2}$/.test(s)) s += ':00';
    s = s.replace(/T(\d):/, 'T0$1:');
    if (!/(Z|[+-]\d{2}:\d{2})$/.test(s)) s += tz;
    return Date.parse(s);
  }

  function decode(b64) {
    try { return decodeURIComponent(escape(atob(b64))); } catch (e) { return ''; }
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () { return legacyCopy(text); });
    }
    return legacyCopy(text);
  }

  function legacyCopy(text) {
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-1000px;opacity:0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? resolve() : reject(); } catch (e) { reject(e); }
      document.body.removeChild(ta);
    });
  }

  function init(root) {
    if (root.__hdInit) return;
    root.__hdInit = true;

    var section = root.closest('.shopify-section') || root.parentElement;
    var tz = '-07:00'; // Cố định giờ PDT (Pacific Daylight Time)
    var hideDays = root.dataset.hideDays !== 'false';
    var rotate = parseInt(root.dataset.rotate, 10) || 0;
    var bars = Array.prototype.slice.call(root.querySelectorAll('.hd-promo__bar'));
    var forced = null, lastBar = null;
    var effect = root.dataset.effect || 'slide_left';
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rotIdx = 0, nextRot = 0, paused = false, animTimer = null;

    // Rê chuột vào bar (desktop) thì tạm dừng xoay để khách kịp bấm
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') paused = true; });
    root.addEventListener('pointerleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    function cleanAnim() {
      clearTimeout(animTimer);
      bars.forEach(function (x) { x.classList.remove('is-entering', 'is-leaving'); });
    }

    // Đổi bar: có hiệu ứng trượt nếu cả 2 bar đều tồn tại
    function swap(from, to) {
      cleanAnim();
      bars.forEach(function (x) { if (x !== from && x !== to) x.hidden = true; });
      if (to) to.hidden = false;
      var animate = from && to && !forced && effect !== 'none' && !reduced && !document.hidden;
      if (!animate) { if (from) from.hidden = true; return; }
      from.hidden = false;
      from.classList.add('is-leaving');
      void to.offsetWidth;
      to.classList.add('is-entering');
      animTimer = setTimeout(function () {
        from.hidden = true;
        from.classList.remove('is-leaving');
        to.classList.remove('is-entering');
      }, 550);
    }

    bars.forEach(function (b) {
      if (b.dataset.type !== 'countdown') return;
      var start = parseDate(b.dataset.start, tz);
      var dur = parseInt(b.dataset.duration, 10) || 0;
      b._start = start;
      b._end = dur > 0 ? start + dur * 60000 : parseDate(b.dataset.end, tz);
      b._pre = (parseFloat(b.dataset.preHours) || 0) * 3600000;
      if (isNaN(b._start) || isNaN(b._end)) console.warn('[Handora promo bar] Sai định dạng ngày giờ:', b.dataset.start, b.dataset.end);
    });

    if (root.dataset.sticky === 'true') {
      section.classList.add('hd-promo-sticky');
      document.documentElement.classList.add('hd-promo-has-sticky');
    }

    function measure() {
      var h = section.classList.contains('hd-promo-empty') ? 0 : root.offsetHeight;
      document.documentElement.style.setProperty('--hd-promo-h', h + 'px');
      queuePush();
    }

    // Ghim header của theme ngay DƯỚI promo bar (2 thanh xếp chồng, không đè nhau).
    // Chỉ tìm trong section Header (không đụng mobile menu / drawer / popup),
    // chỉ chỉnh phần tử đang sticky/fixed và có chiều cao kiểu thanh header (< 250px).
    var headerSec;
    function findHeaderSection() {
      if (headerSec && document.documentElement.contains(headerSec)) return headerSec;
      headerSec = null;
      var el = section.nextElementSibling;
      while (el) {
        if (el.classList && el.classList.contains('shopify-section')) {
          var id = (el.id || '').toLowerCase();
          if (!/menu|drawer|announcement|popup|overlay/.test(id) && (/header/.test(id) || el.querySelector('header'))) {
            headerSec = el; break;
          }
        }
        el = el.nextElementSibling;
      }
      return headerSec;
    }
    function collect(node, depth, out) {
      out.push(node);
      if (depth >= 3) return out;
      for (var c = node.firstElementChild; c; c = c.nextElementSibling) collect(c, depth + 1, out);
      return out;
    }
    // Speed: read every node first, then write only what changed. The old loop
    // toggled a class and then read the next node's size, which made the
    // browser redo the page layout once per node, on every scroll frame.
    var headerMo = null, observedHeader = null;
    function pushHeader() {
      if (root.dataset.sticky !== 'true') return;
      var hs = findHeaderSection();
      if (!hs) return;
      if (hs !== observedHeader && window.MutationObserver) {
        if (!headerMo) headerMo = new MutationObserver(queuePush);
        headerMo.disconnect();
        headerMo.observe(hs, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });
        observedHeader = hs;
      }
      var nodes = collect(hs, 0, []), want = [], i;
      for (i = 0; i < nodes.length; i++) {
        var pos = getComputedStyle(nodes[i]).position;
        var hgt = (pos === 'sticky' || pos === 'fixed') ? nodes[i].offsetHeight : 0;
        want.push(hgt > 0 && hgt < 250);
      }
      for (i = 0; i < nodes.length; i++) {
        if (nodes[i].classList.contains('hd-push') !== want[i]) nodes[i].classList.toggle('hd-push', want[i]);
      }
    }
    var pushQueued = false;
    function queuePush() {
      if (pushQueued) return;
      pushQueued = true;
      requestAnimationFrame(function () { pushQueued = false; pushHeader(); });
    }
    // The header only changes between sticky and not by a class or style change
    // (watched in pushHeader) or a resize, so nothing runs while scrolling.

    // Khi mở cart drawer / menu / popup → hạ layer promo bar để drawer phủ lên trên
    var OVERLAY_SEL = [
      'cart-drawer.active', 'cart-drawer[open]', 'cart-drawer.is-open',
      '.cart-drawer.active', '.cart-drawer.is-open', '.cart-drawer--open',
      '[id*="CartDrawer"].active', '[id*="CartDrawer"].is-open', '[id*="cart-drawer"].active', '[id*="cart-drawer"].is-open',
      '.drawer.is-open', '.drawer--is-open', '.drawer.active', '.drawer[open]',
      'body.js-drawer-open', 'body.drawer-open', 'body.cart-open', 'html.cart-open'
    ].join(',');
    function checkOverlay() {
      var b = document.body, h = document.documentElement;
      if (!b) return;
      var cb = getComputedStyle(b), ch = getComputedStyle(h);
      var locked = cb.overflow === 'hidden' || cb.overflowY === 'hidden' ||
                   ch.overflow === 'hidden' || ch.overflowY === 'hidden' || b.style.position === 'fixed';
      var open = locked || !!document.querySelector(OVERLAY_SEL);
      h.classList.toggle('hd-promo-overlay-open', open);
    }
    var overlayQueued = false;
    function queueOverlay() {
      if (overlayQueued) return;
      overlayQueued = true;
      requestAnimationFrame(function () { overlayQueued = false; checkOverlay(); });
    }
    if (window.MutationObserver) {
      // The theme makes the header fixed/unfixed by toggling classes on <body>
      // (has-scrolled / hide-header), outside the header section, so the header
      // observer alone missed it: the header kept hd-push (top: 48px) after it
      // went back to normal flow and sat 48px too low with a blank band above
      // the logo. Re-check the header on the same <html>/<body> class changes.
      var mo = new MutationObserver(function () { queueOverlay(); queuePush(); });
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
      if (document.body) mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    window.addEventListener('resize', queuePush);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(root);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measure);
    window.addEventListener('load', measure);

    if (root.dataset.compact === 'true') {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hd-ann-slide]'));
      var index = 0, rotationTimer = null, hovered = false, focused = false, manualPause = false, editorPause = false;
      var interval = Math.max(2000, Number(root.dataset.interval) || 3500);
      var pauseButton = root.querySelector('[data-hd-ann-pause]');
      function showSlide(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function(slide,i){slide.classList.toggle('is-active',i===index);slide.setAttribute('aria-hidden',i===index?'false':'true');});
      }
      function stopRotation(){clearInterval(rotationTimer);rotationTimer=null;}
      function syncRotation(){
        stopRotation();
        if(slides.length<2||hovered||focused||manualPause||editorPause||document.hidden)return;
        rotationTimer=setInterval(function(){
          if(!root.isConnected){stopRotation();return;}showSlide(index+1);
        },interval);
      }
      root.addEventListener('mouseenter',function(){hovered=true;syncRotation();});
      root.addEventListener('mouseleave',function(){hovered=false;syncRotation();});
      root.addEventListener('focusin',function(){focused=true;syncRotation();});
      root.addEventListener('focusout',function(event){if(!root.contains(event.relatedTarget)){focused=false;syncRotation();}});
      if(pauseButton)pauseButton.addEventListener('click',function(){manualPause=!manualPause;pauseButton.setAttribute('aria-pressed',String(manualPause));pauseButton.textContent=manualPause?'Resume announcements':'Pause announcements';syncRotation();});
      function selected(event){
        var slide=event.target.closest&&event.target.closest('[data-hd-ann-slide]');
        if(slide&&root.contains(slide)){editorPause=true;showSlide(slides.indexOf(slide));syncRotation();}
      }
      function deselected(){editorPause=false;syncRotation();}
      document.addEventListener('shopify:block:select',selected);
      document.addEventListener('shopify:block:deselect',deselected);
      document.addEventListener('visibilitychange',syncRotation);
      function unload(event){
        if(event.target!==section)return;
        stopRotation();if(headerMo)headerMo.disconnect();if(mo)mo.disconnect();
        window.removeEventListener('resize',queuePush);window.removeEventListener('load',measure);
        document.removeEventListener('visibilitychange',syncRotation);
        document.removeEventListener('shopify:block:select',selected);document.removeEventListener('shopify:block:deselect',deselected);document.removeEventListener('shopify:section:unload',unload);
      }
      document.addEventListener('shopify:section:unload',unload);
      measure();checkOverlay();syncRotation();
      return;
    }

    function stateOf(b, now) {
      if (b.dataset.type !== 'countdown') return 'static';
      if (isNaN(b._start) || isNaN(b._end) || b._end <= b._start || now >= b._end) return null;
      if (now >= b._start) return 'live';
      if (b._pre > 0 && now >= b._start - b._pre) return 'pre';
      return null;
    }

    function pick(now) {
      var pre = null, statics = [];
      for (var i = 0; i < bars.length; i++) {
        var st = stateOf(bars[i], now);
        if (st === 'live') { nextRot = 0; return [bars[i], st]; }
        if (st === 'pre' && !pre) pre = [bars[i], st];
        if (st === 'static') statics.push(bars[i]);
      }
      if (pre) { nextRot = 0; return pre; }
      if (statics.length) {
        if (rotate > 0 && statics.length > 1) {
          if (!nextRot) nextRot = now + rotate * 1000;
          else if (now >= nextRot) {
            if (!paused) rotIdx = (rotIdx + 1) % statics.length;
            nextRot = now + rotate * 1000;
          }
        }
        return [statics[rotIdx % statics.length], 'static'];
      }
      return [null, null];
    }

    function setUnit(b, unit, val) {
      var el = b.querySelector('[data-unit="' + unit + '"]');
      if (!el) return el;
      var num = el.querySelector('b'), txt = pad(val);
      if (num.textContent !== txt) num.textContent = txt;
      return el;
    }

    function render() {
      var now = Date.now(), r;
      if (forced) {
        var fs = stateOf(forced, now);
        r = [forced, fs || (forced.dataset.type === 'countdown' ? 'live' : 'static')];
      } else {
        r = pick(now);
      }
      var b = r[0], st = r[1];

      if (b !== lastBar) {
        swap(lastBar, b);
        section.classList.toggle('hd-promo-empty', !b);
        lastBar = b;
        measure();
      }
      if (!b) return;

      b.classList.toggle('is-pre', st === 'pre');
      b.classList.toggle('is-live', st === 'live');

      // Chỉ đổ mã vào nút khi giờ vàng đã bắt đầu (hoặc bar thường)
      if (st !== 'pre') {
        var slot = b.querySelector('[data-code-slot]');
        if (slot && !slot.textContent) slot.textContent = decode(b.dataset.code || '');
      }

      if (b.dataset.type === 'countdown') {
        var target = st === 'pre' ? b._start : b._end;
        var diff = Math.max(0, (target || 0) - now);
        if (isNaN(diff)) diff = 0;
        var t = Math.floor(diff / 1000);
        var d = Math.floor(t / 86400);
        var dayTile = setUnit(b, 'd', d);
        setUnit(b, 'h', Math.floor((t % 86400) / 3600));
        setUnit(b, 'm', Math.floor((t % 3600) / 60));
        setUnit(b, 's', t % 60);
        if (dayTile) dayTile.hidden = hideDays && d === 0;
        b.classList.toggle('is-urgent', st === 'live' && diff > 0 && diff <= 5 * 60000);
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.hd-promo__code');
      if (!btn) return;
      var bar = btn.closest('.hd-promo__bar');
      var code = decode(bar.dataset.code || '');
      if (!code) return;
      var sr = bar.querySelector('.hd-promo__sr');
      copyText(code).then(function () {
        btn.classList.add('is-copied');
        if (sr) sr.textContent = 'Code ' + code + ' copied';
        clearTimeout(btn.__t);
        btn.__t = setTimeout(function () { btn.classList.remove('is-copied'); }, 1800);
      }).catch(function () {
        if (sr) sr.textContent = 'Code: ' + code;
      });
    });

    document.addEventListener('shopify:block:select', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.hd-promo__bar');
      if (b && root.contains(b)) { forced = b; render(); }
    });
    document.addEventListener('shopify:block:deselect', function () { forced = null; render(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) render(); });

    // Speed: one tick per second, on the second (the countdown only shows
    // seconds), instead of 4 times a second; nothing runs while the tab is hidden.
    render();
    (function tick() {
      if (!document.documentElement.contains(root)) return;
      if (!document.hidden) { render(); checkOverlay(); }
      setTimeout(tick, 1000 - (Date.now() % 1000) + 20);
    })();
  }

  window.HdPromo = {
    initAll: function () {
      document.querySelectorAll('.hd-promo').forEach(init);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.HdPromo.initAll);
  else window.HdPromo.initAll();
  document.addEventListener('shopify:section:load', window.HdPromo.initAll);
})();
